const translations = {
  'source code repository': 'repozytorium kodu źródłowego',
};

export default translations;
